import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { handleCallback } = useAuth();

    useEffect(() => {
        const token = searchParams.get('token');
        const error = searchParams.get('error');

        if (error) {
            console.error('Auth error:', error);
            navigate('/login?error=' + error);
            return;
        }

        if (token) {
            handleCallback(token);
            navigate('/admin');
            return;
        }

        axios.get(`${API}/auth/me`)
            .then(() => {
                handleCallback('session');
                navigate('/admin');
            })
            .catch(() => navigate('/'));
    }, [searchParams, handleCallback, navigate]);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center">
            <div className="text-center">
                <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto mb-4" />
                <p className="text-muted-foreground font-mono">Authentifizierung...</p>
            </div>
        </div>
    );
}
